import React from 'react'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import { Fade } from '@material-ui/core'
import { Collapse } from '@material-ui/core'

import { StdCard } from 'components'
import Collective from '../Collective'
import TableDetail from '../TableDetail'
import PRBudget from '../PRBudget'

import { ProcurementBody } from 'routes/ProcurementSystem/styled'

const General = props => {
  const { isCreate = false, isEdit = false, change, valueForm, isDetail = false } = props

  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <StdCard title='General Information'>
          <Collective change={change} isCreate={isCreate} isEdit={isEdit} isDetail={isDetail} />
          {(isCreate || isEdit) ? (
            <TableDetail change={change} isCreate={isCreate} isEdit={isEdit} />
          ) : null}
          {(isCreate || isEdit) ?
            <Collapse in={valueForm && valueForm.status >= 0} timeout={500}>
              <PRBudget isCreate={isCreate} isEdit={isEdit} valueForm={valueForm} change={change} />
            </Collapse>
            : null}
        </StdCard>
      </ProcurementBody>
    </Fade>
  )
}

const mapStateToProps = state => {
  return {
    valueForm: getFormValues('formRFQ')(state),
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(General)
